<div class="error-shell">
  @if (authService.isAuthenticated()) {
    <app-admin-header></app-admin-header>
  } @else {
    <app-header></app-header>
  }

  <div class="error-shell__body">
    @if (authService.isAuthenticated()) {
      <app-admin-sidebar></app-admin-sidebar>
    }
    <main class="error-shell__content">
      <ng-content></ng-content>
    </main>
  </div>

  @if (authService.isAuthenticated()) {
    <app-admin-footer></app-admin-footer>
  } @else {
    <app-footer></app-footer>
  }
</div>
